import service from "@/utils/request";

/** 列表*/
export function getLotteryActivityList(data) {
  return service({
    url: "/service/admin/lotteryList",
    method: "post",
    data,
  });
}
/** 新增彩票活动*/
export function addLotteryActivity(data) {
  return service({
    url: "/service/admin/addLottery",
    method: "post",
    data,
  });
}
/** 编辑彩票活动*/
export function editLotteryActivity(data) {
  return service({
    url: "/service/admin/editLottery",
    method: "post",
    data,
  });
}
/** 彩票活动详情*/
export function getLotteryActivityView(data) {
  return service({
    url: "/service/admin/lotteryView",
    method: "post",
    data,
  });
}
/** 删除彩票活动*/
export function deleteLotteryActivity(data) {
  return service({
    url: "/service/admin/lotteryDelete",
    method: "post",
    data,
  });
}
/** 彩票活动-导出*/
export function exportLotteryActivity(params) {
  return service({
    url: "/service/admin/lotteryTicketExport",
    method: "get",
    params,
  });
}
/** 彩票活动-数据池*/
export function getLotteryTicketStatistics(data) {
  return service({
    url: "/service/admin/lotteryTicketStatistics",
    method: "post",
    data,
  });
}
/** 彩票活动-彩票池数据导入*/
export function lotteryTicketImport(data) {
  return service({
    url: "/service/admin/lotteryTicketImport",
    method: "post",
    data,
  });
}
/** 彩票活动-单个活动彩票上传*/
export function lotteryTicketUpload_excel(data) {
  return service({
    url: "/service/admin/upload_excel",
    method: "post",
    data,
  });
}

